module.exports = __webpack_public_path__ + "img/icon_4_28.84de7364.png";